const _ = require("lodash");
const {
  linkedInSectorsMapping,
  linkedInFunctionsMapping,
  linkedInCareerLevelsMapping,
  linkedInEmploymentTypesMapping,
  ALLOWED_VIDEO_FORMATS,
  CLOUDINARY
} = require("./constants");
const { channelsByShortName } = require("../../../data/app__channels");

const { CLOUDINARY_CLOUD_NAME } = CLOUDINARY;
const CLOUDINARY_BASE_URL = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}`;

const isVideo = (url) =>
  url ? ALLOWED_VIDEO_FORMATS.some((format) => url.endsWith(`.${format}`)) : false;

// not used anymore
const isImage = (url) =>
  url.startsWith("https://eu.ui-avatars.com/") ||
  url.endsWith(".jpg") ||
  url.endsWith(".jpeg") ||
  url.endsWith(".png") ||
  url.endsWith(".gif") ||
  url.endsWith(".webp");

const noop = () => {
  // Nothing
};

const imageDimensionsCache = {};

const domainPattern = new RegExp("(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}", "i");
const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return !!domainPattern.test(string) && (url.protocol === "http:" || url.protocol === "https:");
};

const withHttp = (url) => {
  if (!url) {
    return url;
  }

  url = url.trim();

  if (!/^https?:\/\//i.test(url)) {
    if (url.length === 6 && url.toLowerCase() === "http:/") {
      return "";
    } else {
      url = "http://" + url;
    }
  }

  if (/^https?:\/\/https:\/\//i.test(url)) {
    url = url.replace(/^https?:\/\/https:\/\//, "https://");
  } else if (/^https?:\/\/http:\/\//i.test(url)) {
    url = url.replace(/^https?:\/\/http:\/\//, "http://");
  }
  return url;
};

function getDisplayLink(url) {
  if (!url) {
    return url;
  }
  return new URL(url).hostname.replace("www.", "");
}

const secsToHHMMSS = (secs) => {
  const sec_num = parseInt(secs, 10);
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor(sec_num / 60) % 60;
  const seconds = sec_num % 60;

  return [hours, minutes, seconds]
    .map((v) => (v < 10 ? "0" + v : v))
    .filter((v, i) => v !== "00" || i > 0)
    .join(":");
};

const getSecondsLeft = (toDate, fromDate) =>
  Math.floor((toDate.getTime() - fromDate.getTime()) / 1000);

const dateToDDMMhhmmss = (d) =>
  ("00" + d.getDate()).slice(-2) +
  "." +
  ("00" + (d.getMonth() + 1)).slice(-2) +
  " " +
  ("00" + d.getHours()).slice(-2) +
  ":" +
  ("00" + d.getMinutes()).slice(-2);

const round = (num, places = 2) => parseFloat(num.toFixed(places));

function getCloudinaryLinkWithoutCloudinaryCrop(url = "") {
  if (!url) return url;

  return url
    .replace(/c_crop.*?\//g, "")
    .replace(/c_fill.*?\//g, "")
    .replace(/c_mfit.*?\//g, "");
}

const getCloudinaryCropParamsFromURL = (url) => {
  const cloudinaryCropString = new RegExp("/c_crop.*?/", "g").exec(url);

  if (cloudinaryCropString == null) {
    return {
      x: null,
      y: null,
      width: null,
      height: null,
      ar: null
    };
  }

  const matchParam = (param) => {
    const match = new RegExp(`${param}_.*?(,|\/)`, "g").exec(cloudinaryCropString[0]);
    if (!match) {
      return null;
    }
    const parsedValue = parseFloat(match[0].substring(param.length + 1, match[0].length));
    return !isNaN(parsedValue) ? parsedValue : null;
  };

  return {
    x: matchParam("x"),
    y: matchParam("y"),
    width: matchParam("w"),
    height: matchParam("h"),
    ar: matchParam("ar")
  };
};

const autoCropCloudinary = (url, ar) => {
  const cloudinaryUrl = getCloudinaryLinkWithoutCloudinaryCrop(url);
  if (!cloudinaryUrl) return url;

  return cloudinaryUrl.replace("/upload/", `/upload/c_crop,ar_${ar}/`);
};

function getURLVersion(url) {
  const versionRegex = /\/v\d{10}\//;
  const regexMatch = url.match(versionRegex);
  if (regexMatch?.length === 1) {
    return regexMatch[0].replace(/\//g, "");
  }

  return "";
}

function removeShutterstockTransformations(url) {
  const resourceType = isVideo(url) ? "video" : "image";
  const extension = url.split(".").pop();
  const version = getURLVersion(url);
  const cloudinaryShutterstockFolder = "organizations-stock-images";

  let publicId;
  if (url.includes(cloudinaryShutterstockFolder)) {
    publicId = url.substring(url.lastIndexOf(cloudinaryShutterstockFolder), url.lastIndexOf("."));
  } else {
    return url;
  }

  if (version) {
    return `${CLOUDINARY_BASE_URL}/${resourceType}/upload/${version}/${publicId}.${extension}`;
  }

  return `${CLOUDINARY_BASE_URL}/${resourceType}/upload/${publicId}.${extension}`;
}

const simpleCleanTitle = (jobTitle = "") => {
  let cleanTitle = jobTitle.replace(/\(?(m|w)\/(w|m)\/(d|i)\)?/g, "");
  cleanTitle = cleanTitle.replace("  ", " ");

  cleanTitle = cleanTitle.trim();
  cleanTitle = cleanTitle.toLowerCase();
  return cleanTitle;
};

function extractHashtags(text) {
  const hastagStrings = (text.match(/[^#]+/g) || []).slice(1);
  return hastagStrings.map((label) => ({ label: "#" + label + " ", value: "#" + label + " " }));
}

function extractPageId(pageLink) {
  let pageId = "716047581885055";
  if (pageLink.includes("graph.facebook.com")) {
    pageId = ((pageLink.match(/[^https://graph\.facebook\.com]+\//g) || [])[0] || "").replace(
      "/",
      ""
    );
  }
  return pageId;
}

function extractPictureName(imageUrl) {
  if (!imageUrl.includes("res.cloudinary.com")) {
    return "";
  }
  let imageName = imageUrl.split("tb-campaign-photos").pop();
  if (imageName == imageUrl) {
    imageName = imageUrl.split("/").pop();
  }
  imageName = imageName.split(".");
  imageName.pop();
  imageName = imageName.join(".");
  if (imageName.includes("tb-campaign-photos")) {
    return imageName;
  } else {
    return "tb-campaign-photos" + imageName;
  }
}

function getLinkedInFields(post) {
  if (post.channel != "linkedin") {
    return {};
  }
  const {
    careerLevel,
    employmentType,
    function: jobFunction,
    sector,
    pageName,
    linkedInCompanyId
  } = post.channelData;
  const industry = linkedInSectorsMapping[sector] || "";
  const mappedCareerLevel = linkedInCareerLevelsMapping[careerLevel] || "0";
  const mappedEmploymentType = linkedInEmploymentTypesMapping[employmentType] || "";
  const mappedJobFunction = linkedInFunctionsMapping[jobFunction] || "";
  return {
    industry: String(industry),
    carrerLevel: String(mappedCareerLevel),
    employmentType: String(mappedEmploymentType),
    functions: String(mappedJobFunction),
    location: pageName || "",
    companyId: linkedInCompanyId || ""
  };
}

const convertPostsToAdPreviews = (posts = [], campaignData = {}) => {
  const adPreviewObject = { checklist: {}, staging: {}, released: {} };
  posts.forEach((post) => {
    try {
      const {
        channelData = {},
        creatives = [],
        channel,
        teaserText,
        type,
        jobPostingMarkup
      } = post;
      const { displayLink, url, pageName, pageLogo, subHeadline, companyName, title } = channelData;
      const { locations = [] } = campaignData;
      // Get hashtags
      const hashtags = extractHashtags(teaserText);
      const photos = _.map(creatives, (image_url) => ({
        image_url,
        name: extractPictureName(image_url)
      }));
      const benefits = "Wir bieten:\n" + (teaserText.split("Wir bieten:")[1] || "");
      const mainTeaserText = teaserText.split("Wir bieten:")[0] || "";
      const pageId = extractPageId(pageLogo);
      const state = locations && locations[0] && locations[0].stateOfLoc;
      const location = locations && locations[0] && locations[0].location;
      let channelObject = {
        accepted: false,
        benefits: benefits || "",
        companyName: companyName || "",
        companyNameShort: companyName || "",
        hashtags: hashtags || [],
        headline: title || "",
        link: displayLink || "",
        jobPostingUrl: url || "",
        title: title || "",
        jobTitle: title || "",
        pageId: pageId || "",
        pageLogo: pageLogo || "",
        pageName: pageName || "",
        photos: photos || [],
        teaserText: mainTeaserText || "",
        description: mainTeaserText || "",
        longHeadline: subHeadline || title + " gesucht",
        formattedAdText: teaserText || "",
        jobPostingMarkup: jobPostingMarkup || ""
      };

      if (state && location) {
        channelObject.state = state;
        channelObject.location = location;
      }
      if (channel == "linkedin") {
        const linkedInFields = getLinkedInFields(post);
        channelObject = { ...channelObject, ...linkedInFields };
      }
      adPreviewObject[type][channel] = channelObject;
    } catch (e) {
      return;
    }
  });
  return adPreviewObject;
};

const preparePostsForSaving = ({
  posts,
  channelsData,
  orgaId,
  campaignId,
  username = "",
  createReleased = true
}) => {
  if (!posts || !channelsData) {
    return [];
  }

  const createdDate = new Date().toISOString();
  const createdBy = username;

  const mappedPosts = Object.values(posts).flatMap((channelPosts) => {
    const mapPost = (type) =>
      channelPosts.map((post) => {
        const foundChannelDataByPostNumber = (channelsData[post.channel] || []).find(
          (channelData) => channelData.postNumber === post.postNumber
        );

        return {
          ...post,
          type,
          ...(campaignId ? { campaignId } : {}),
          ...(orgaId ? { orgaId } : {}),
          createdDate,
          createdBy,
          channel: post.channel,
          channelData: foundChannelDataByPostNumber || []
        };
      });

    // Staging posts are the posts that have been modified on internal tools and are not released yet
    const channelData = mapPost("staging");

    // Released posts are the posts that have been released to the public
    // either modified by the client or released by internal tools
    const releasedPosts = createReleased ? mapPost("released") : [];

    return [...channelData, ...releasedPosts];
  });

  return mappedPosts;
};

const searchOptions = ({ options, searchText, key }) => {
  const regex = new RegExp(searchText, "i");
  return searchText === ""
    ? options
    : options.filter((option) => (key ? option[key] : option).search(regex) !== -1);
};

const getRandomId = () => "id" + Math.random().toString(16).slice(2);

// Fetches an image's dimension
async function getImageDimensions(imageUrl) {
  return new Promise((resolve, reject) => {
    // If dimensions are cached no need to fetch images again
    if (imageDimensionsCache[imageUrl]) {
      return resolve(imageDimensionsCache[imageUrl]);
    }
    if (isVideo(imageUrl)) {
      const video = document.createElement("video");
      video.onloadedmetadata = () => {
        const result = {
          ar: video.videoWidth / video.videoHeight,
          width: video.videoWidth,
          height: video.videoHeight
        };
        imageDimensionsCache[imageUrl] = result;
        resolve(result);
      };
      video.onerror = () => {
        resolve({});
      };
      video.src = imageUrl;
    } else {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        // get image data
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        const result = { ar: width / height, width, height };
        imageDimensionsCache[imageUrl] = result;
        resolve(result);
      };
      img.onerror = reject;
      img.src = imageUrl;
    }
  });
}

const getRedirectUrl = () => {
  let href = window.location.href.replace("http://", "").replace("https://", "").split("/");
  href = href.slice(1).join("/");
  return href;
};

/**
 * Determines if the channel from the loop should be updated based on the current channel being edited.
 *
 * @param {string} loopChannel - The channel being iterated over in the loop.
 * @param {string} editedChannelShortName - The short name of the channel currently being edited.
 * @param {number} editedChannelCategory - The category of the channel currently being edited.
 * @param {object|null} imageSpecs - Specifications of the image (if available).
 * @returns {boolean} Returns true if the loop channel should be updated because it belongs to the same category as the edited channel.
 *
 * @example
 * // If you're editing a Facebook post (category 1), this checks if the loop channel (e.g., Instagram) is also category 1.
 */
const shouldUpdateOtherChannel = (
  loopChannel,
  editedChannelShortName,
  editedChannelCategory,
  imageSpecs
) => {
  const loopChannelCategory = channelsByShortName[loopChannel].category;

  return (
    loopChannel !== editedChannelShortName &&
    editedChannelCategory != null &&
    imageSpecs != null &&
    loopChannelCategory === editedChannelCategory
  );
};

const prepareNewPosts = async ({
  posts,
  updatedChannelCategory,
  key,
  value,
  channelShortName,
  postNumber
}) => {
  // Get aspect ratio from new creative
  let imageSpecs;
  if (key === "creatives") {
    const imageUrl = value[0];
    imageSpecs = await getImageSpecs(imageUrl);
  }

  // Create a copy of the currently existing posts
  const newPosts = { ...posts };

  const isAssetKey = key === "mediaAssets" || key === "creatives";

  // Go over each post
  Object.keys(newPosts).forEach((channel) => {
    // Handle new creative copy to unedited posts
    let newCreativeUrlHashForOtherChannel = null;
    if (
      key === "creatives" &&
      shouldUpdateOtherChannel(channel, channelShortName, updatedChannelCategory, imageSpecs)
    ) {
      newCreativeUrlHashForOtherChannel = getCreativeUrlForOtherChannel({
        channel,
        imageSpecs,
        imageUrl: value[0]
      });
    } else if (
      key === "logos" &&
      shouldUpdateOtherChannel(channel, channelShortName, updatedChannelCategory, imageSpecs)
    ) {
      newCreativeUrlHashForOtherChannel = { logos: value };
    }

    if (channel === channelShortName) {
      newPosts[channel] = posts[channel].map((post) => {
        if (Number(post.postNumber) === Number(postNumber)) {
          // update post with new value, and editedState
          return {
            ...post,
            [key]: value,
            editedStates: { ...(post.editedStates || {}), [key]: true }
          };
        }
        return post; // do not update other posts
      });
    } else if (
      // copy updates to posts with the same channel category
      // if you're editing a Facebook post (category 1), this checks if the loop channel (e.g., Instagram) is also category 1.
      updatedChannelCategory != null &&
      channelsByShortName[channel].category === updatedChannelCategory &&
      !isAssetKey
    ) {
      newPosts[channel] = posts[channel].map((post) => {
        if (!post.editedStates?.[key] && post.postNumber === postNumber) {
          // copy new value if it is unedited on the post
          let newValue = value;

          if (key === "logos") {
            newValue = newCreativeUrlHashForOtherChannel?.logos || [""];
          } else if (typeof value == "string") {
            newValue = value.substring(0, channelsByShortName[channel].limits[key]);
          }

          return {
            ...post,
            [key]: newValue
          };
        }
        return post; // do not update other posts
      });
    }
  });

  return newPosts;
};

// Returns ar, width, height of image url
async function getImageSpecs(imageUrl) {
  const imageSpecs = {};
  if (imageUrl.startsWith("https://res.cloudinary.com/")) {
    imageSpecs.isCloudinary = true;
  }
  try {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = imageUrl;
    });
    imageSpecs.ar = img.naturalWidth / img.naturalHeight;
    imageSpecs.width = img.naturalWidth;
    imageSpecs.height = img.naturalHeight;
    if (imageSpecs.isCloudinary) {
      // replace calculated values with Cloudinary params if possible
      const cloudinaryCropParams = getCloudinaryCropParamsFromURL(imageUrl);
      imageSpecs.ar = cloudinaryCropParams.ar || imageSpecs.ar;
      imageSpecs.width = cloudinaryCropParams.width || imageSpecs.width;
      imageSpecs.height = cloudinaryCropParams.height || imageSpecs.height;
    }
    return imageSpecs;
  } catch (_) {
    return null;
  }
}

// formats a creative url to a channel by allowed aspect ratios, dimensions if possible
function getCreativeUrlForOtherChannel({
  channel,
  imageSpecs: { isCloudinary, ar, width = 0, height = 0 },
  imageUrl
}) {
  const { minAspect, maxAspect, minHeight, minWidth, defaultAspect } = channelsByShortName[channel];
  // Channel does not have images
  if (!minAspect || !maxAspect) return {};
  if (isCloudinary) {
    let newUrl = imageUrl.replace(/c_mfit.*?\//g, ""); // delete minfits from image
    if (minWidth && width < minWidth) {
      newUrl = newUrl.replace("/upload/", `/upload/c_mfit,w_${minWidth + 1}/`);
    }
    if (minHeight && height < minHeight) {
      newUrl = newUrl.replace("/upload/", `/upload/c_mfit,h_${minHeight + 1}/`);
    }
    // Image ar is different from channel ar min or max => recrop the image to the channels ar
    if (ar !== minAspect && ar !== maxAspect) {
      // If channel is a google display channel, then we need to have both ar versions of the creative

      let aspectRatio = defaultAspect;

      if (!defaultAspect) {
        aspectRatio = Math.abs(minAspect - ar) < Math.abs(maxAspect - ar) ? minAspect : maxAspect;
      }

      newUrl = autoCropCloudinary(newUrl, aspectRatio);
    }
    return { creatives: [newUrl] };
  } else if (ar < minAspect || ar > maxAspect) {
    // Image is not cloudinary, the ar is too small or too big, we cannot crop it, do not use the image
    return {};
  } else {
    // Image is not cloudinary, ar is inside the allowed range, use it
    return { creatives: [imageUrl] };
  }
}

function constructAdUrl({ selectedChannelCampaignData, postData, selectedCreativeIndexToEdit }) {
  try {
    const matchedPlatformAdCreativeEntry = selectedChannelCampaignData.platformAds?.filter(
      (pc) => pc.postNumber == postData?.postNumber && pc.mediaIndex == selectedCreativeIndexToEdit
    );

    let finalUrl = "";
    switch (selectedChannelCampaignData.channel) {
      case "facebook":
      case "instagram":
        finalUrl = generateFacebookAdUrl({
          selectedChannelCampaignData,
          matchedPlatformAdCreativeEntry
        });
        break;
      case "youtube":
      case "google-display":
      case "ebay-kleinanzeigen":
        finalUrl = generateGoogleAdUrl({
          selectedChannelCampaignData,
          matchedPlatformAdCreativeEntry
        });
        break;
    }
    return finalUrl;
  } catch (error) {
    return "";
  }
}

function generateFacebookAdUrl({
  selectedChannelCampaignData,
  matchedPlatformAdCreativeEntry = []
}) {
  let adId = matchedPlatformAdCreativeEntry[0]?.platformAdId;
  const baseUrl = "https://business.facebook.com/adsmanager/manage/ads/edit?";
  const dynamicUrl = `${selectedChannelCampaignData?.platformAccountId}&business_id=1775520372707006&selected_campaign_ids=${selectedChannelCampaignData?.platformCampaignId}&selected_ad_ids=${adId}`;
  const finalUrl = baseUrl.concat(dynamicUrl) || "";
  return finalUrl;
}

function generateGoogleAdUrl({ selectedChannelCampaignData, matchedPlatformAdCreativeEntry = [] }) {
  const adId = matchedPlatformAdCreativeEntry[0]?.platformAdId;
  const campaignId = selectedChannelCampaignData?.platformCampaignId;
  const adSetId = selectedChannelCampaignData?.platformAdsetId;

  const baseUrl = "https://ads.google.com/aw/ads/edit/display?";
  const dynamicUrl = `campaignId=${campaignId}&ocid=818738140&adId=${adId}&adGroupIdForAd=${adSetId}&adTypeId=35`;
  const finalUrl = baseUrl.concat(dynamicUrl) || "";

  return finalUrl;
}

function hasCaps(str, whitelist = []) {
  const words = str.split(" ");

  for (let word of words) {
    let consecutiveCaps = 0;
    for (let i = 0; i < word.length; i++) {
      if (word[i] >= "A" && word[i] <= "Z") {
        consecutiveCaps++;
        if (consecutiveCaps === 3 && !whitelist.includes(word)) {
          return true;
        }
      } else {
        consecutiveCaps = 0;
      }
    }
  }

  return false;
}

function getScaleFactor(originalWidth, originalHeight, targetWidth, targetHeight) {
  const widthScale = targetWidth / originalWidth;
  const heightScale = targetHeight / originalHeight;
  return Math.min(widthScale, heightScale);
}

const fontSizeConfig = {
  portrait: [
    { minLength: 0, maxLength: 29, size: 115 },
    { minLength: 30, maxLength: 39, size: 110 },
    { minLength: 40, maxLength: 50, size: 105 },
    { minLength: 51, size: 95 }
  ],
  vertical: [
    { minLength: 0, maxLength: 29, size: 85 },
    { minLength: 30, maxLength: 39, size: 80 },
    { minLength: 40, maxLength: 50, size: 75 },
    { minLength: 51, size: 70 }
  ],
  landscape: [
    { minLength: 0, maxLength: 29, size: 60 },
    { minLength: 30, maxLength: 39, size: 55 },
    { minLength: 40, maxLength: 50, size: 50 },
    { minLength: 51, size: 45 }
  ]
};

const getPrintFontSize = (orientation, textLength) => {
  const rules = fontSizeConfig[orientation] || fontSizeConfig.vertical;
  const text = rules.find(
    (rule) =>
      textLength >= rule.minLength && (rule.maxLength === undefined || textLength <= rule.maxLength)
  );
  return text?.size || 80;
};

function hasHashtags(str) {
  // This regex matches a # followed by at least one letter or number (word character), not preceded by a word character (to avoid mid-word #)
  // and not followed by whitespace or punctuation only.
  // It will match hashtags like #word, #123, #hello_world, but not just # or #! or # .
  return /(^|\s)#[\wäöüÄÖÜß]+/i.test(str);
}

module.exports = {
  isImage,
  isVideo,
  noop,
  isValidHttpUrl,
  withHttp,
  secsToHHMMSS,
  getSecondsLeft,
  dateToDDMMhhmmss,
  round,
  getCloudinaryLinkWithoutCloudinaryCrop,
  getCloudinaryCropParamsFromURL,
  autoCropCloudinary,
  getImageDimensions,
  simpleCleanTitle,
  removeShutterstockTransformations,
  convertPostsToAdPreviews,
  preparePostsForSaving,
  extractPageId,
  getDisplayLink,
  searchOptions,
  getRandomId,
  getRedirectUrl,
  prepareNewPosts,
  getImageSpecs,
  getCreativeUrlForOtherChannel,
  constructAdUrl,
  hasCaps,
  hasHashtags,
  getScaleFactor,
  getPrintFontSize
};
